import styled from 'styled-components';
import { FlexContainer as FlexContainer_ } from '@taxdown/piccolo-web';

export const FlexContainer = styled(FlexContainer_)`
  height: 100%;
  @media screen and (max-width: ${({ theme: { mediaQueries } }) =>
      mediaQueries.desktop_extra_small_width}) {
    height: 400px;
  }
`;
